import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { trackAppStoreClick } from '@/lib/posthog';

const APP_STORE_URL = 'https://apps.apple.com/us/app/athlete-space/id6758096470';

export const TelemetryFooter = () => {
  return (
    <footer className="relative py-16 border-t border-white/10">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Brand - static logo only, no animation */}
          <div className="flex items-center gap-3">
            <img 
              src="/AppIcon.png" 
              alt="Athlete Space" 
              className="h-5 w-auto opacity-50 pointer-events-none"
            />
            <span className="text-[10px] font-mono tracking-[0.2em] text-slate-600 uppercase">
              Performance System
            </span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center gap-8 text-[10px] font-mono tracking-[0.15em] text-slate-600 uppercase">
            <Link to="/about" className="hover:text-slate-400 transition-colors">About</Link>
            <Link to="/science" className="hover:text-slate-400 transition-colors">Science & AI</Link>
            <Link to="/privacy" className="hover:text-slate-400 transition-colors">Privacy</Link>
            <Link to="/faq" className="hover:text-slate-400 transition-colors">FAQ</Link>
            <Link to="/login" className="hover:text-slate-400 transition-colors">Sign In</Link>
          </div>
        </div>

        {/* Final CTA + App Store */}
        <motion.div
          className="mt-16 pt-12 border-t border-white/10 text-center flex flex-col items-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-lg font-mono font-light text-slate-300 tracking-tight mb-2">
            Train smarter. Get the app.
          </p>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackAppStoreClick('footer')}
            className="mt-4"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
              className="h-10"
            />
          </a>
          <Link
            to="/login"
            className="inline-block text-sm font-mono tracking-[0.1em] text-slate-300 hover:text-slate-200 transition-colors border-b border-slate-700 hover:border-slate-500 pb-1 mt-6 mb-4"
          >
            Enter the Performance System
          </Link>
          <p className="text-xs font-mono tracking-wider text-slate-600 mt-3">
            Built for endurance athletes who train by signal, not guesswork.
          </p>
        </motion.div>

        {/* Bottom line */}
        <motion.div
          className="mt-12 pt-8 border-t border-white/10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[9px] font-mono tracking-wider text-slate-700">
            <span>© 2025 Athlete Space</span>
            <span>Signal-driven training intelligence</span>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};
